// hooks/useConsentNotice.js — Anamoria SPA
// v1.0 — Consent PR E4b (Oct 4, 2026). Section-level loader for a stored consent notice, so a screen
//   with several checkboxes for the SAME notice (the quiet-note days) fetches the wording ONCE rather
//   than once per checkbox (plan v0.26 §6; PR-E spec v0.3 §6 / D-E4.2). Fail-closed exactly like
//   ConsentCheckbox: until the notice is stored (PR B stores it at Step 5), GET /notices/{docType}
//   404s and this returns { ready:false } — so the caller renders nothing. When disabled (flag off)
//   it never fetches.
import { useEffect, useState } from 'react';

export function useConsentNotice(api, docType, enabled = true) {
  const [state, setState] = useState({ ready: false, shownHash: null, body: null, version: null });
  useEffect(() => {
    if (!api || !docType || !enabled) { setState({ ready: false, shownHash: null, body: null, version: null }); return undefined; }
    let cancelled = false;
    api.get(`/notices/${encodeURIComponent(docType)}`)
      .then((data) => {
        if (!cancelled && data && typeof data.body === 'string' && data.contentHash) {
          setState({ ready: true, shownHash: data.contentHash, body: data.body, version: data.version ?? null });
        }
      })
      .catch(() => { /* 404 NOTICE_NOT_FOUND or any error: stay not-ready (fail closed) */ });
    return () => { cancelled = true; };
  }, [api, docType, enabled]);
  return state;
}
